export * from './src/bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.meta.js';
